/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SubmitContentReportResponse, SubmitContentReportVars } from '../openapi-types.gen.js';

export type { SubmitContentReportResponse, SubmitContentReportVars } from '../openapi-types.gen.js';

export const useSubmitContentReport = createMutationHook<SubmitContentReportVars, SubmitContentReportResponse, unknown>({
  specName: 'useSubmitContentReport',
  path: '/v1/content-reports',
  method: 'POST',
  resolveUrl: (vars: SubmitContentReportVars) => `/v1/content-reports`,
  buildBody: (vars: SubmitContentReportVars) => ({ entityType: vars.entityType, entityId: vars.entityId, reason: vars.reason }),
  parseResponse: (raw: unknown): SubmitContentReportResponse => raw as SubmitContentReportResponse,
  
  
  
});
